import { useMemo, useState } from 'react'
import { WORKSPACE_ACCENTS, WORKSPACE_ICONS } from '@/services/workspaces/workspacePresets'

export function useCreateWorkspaceForm(initial = {}) {
  const [name, setName] = useState(initial.name ?? '')
  const [description, setDescription] = useState(initial.description ?? '')
  const [icon, setIcon] = useState(
    WORKSPACE_ICONS.includes(initial.icon) ? initial.icon : WORKSPACE_ICONS[0],
  )
  const [accent] = useState(initial.accent ?? WORKSPACE_ACCENTS[0].id)
  const [nameError, setNameError] = useState('')
  const [submitError, setSubmitError] = useState('')
  const canSubmit = name.trim().length > 0
  const payload = useMemo(
    () => ({
      name: name.trim(),
      description: description.trim() || null,
      icon,
      accent,
    }),
    [accent, description, icon, name],
  )
  const clearErrors = () => {
    setNameError('')
    setSubmitError('')
  }
  const handleSetName = (value) => {
    setName(value)
    if (nameError) setNameError('')
    if (submitError) setSubmitError('')
  }
  return {
    name,
    setName: handleSetName,
    description,
    setDescription,
    icon,
    setIcon,
    accent,
    canSubmit,
    payload,
    nameError,
    setNameError,
    submitError,
    setSubmitError,
    clearErrors,
  }
}
